export default __webpack_public_path__ + "1b62dba1aee45d6239edd2fb6f67b58f.jpg";